import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { Link } from 'react-router-dom';
import { pageTitle, site } from '../site';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
    useDocumentTitle(pageTitle('Page non trouvée'));
    return (
        <div className={`container ${styles.notFound}`}>
            <h1 className={styles.code}>404</h1>
            <p>
                <strong>Page non trouvée :(</strong>
            </p>
            {site.notFoundLink === 'wikipedia' ? (
                <p>
                    Vous vous êtes perdus ? Découvrez{' '}
                    <a href="https://fr.wikipedia.org/wiki/Mafate">le cirque de Mafate sur Wikipédia</a> !
                </p>
            ) : (
                <p>
                    Vous vous êtes perdus ? Vous pouvez <Link to="/">retourner à l'accueil</Link>.
                </p>
            )}
        </div>
    );
}
